export type UIVersion = 'modern' | 'classic'

const KEY = 'bc.ui.version'

export function getUIVersion(): UIVersion {
  try {
    return localStorage.getItem(KEY) === 'modern' ? 'modern' : 'classic'
  } catch (_e) {
    return 'classic'
  }
}

export function setUIVersion(version: UIVersion): void {
  try {
    localStorage.setItem(KEY, version)
  } catch (_e) {
    // localStorage unavailable -- preference won't persist
  }
}

export function clearUIVersion(): void {
  try {
    localStorage.removeItem(KEY)
  } catch (_e) {
    // localStorage unavailable
  }
}
